/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import RoomEvent from '../../event/RoomEvent'
import ReservationEvent from '../../event/ReservationEvent'
import { RoomState } from '../state/RoomState'

class RoomsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case RoomEvent.fetchAll:
      case ReservationEvent.fetchMonthlyByDate:
        const rooms = payload.rooms.map(room => {
          return new RoomState(room)
        })
        return List(rooms)
      default:
        return state
    }
  }
}

export default new RoomsStore()
